import { render, staticRenderFns } from "./stationBack.vue?vue&type=template&id=184758c8&scoped=true"
import script from "./stationBack.vue?vue&type=script&lang=js"
export * from "./stationBack.vue?vue&type=script&lang=js"
import style0 from "./stationBack.vue?vue&type=style&index=0&id=184758c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184758c8",
  null
  
)

export default component.exports